module.exports = __webpack_public_path__ + "img/training.b04a073a.svg";